import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import {
  URL_CONTROL_PANEL_ACTION_AGENT,
  URL_CONTROL_PANEL_AGENT_STATISTICS,
  URL_CONTROL_PANEL_GENERAL_INVESTMENT,
  URL_CONTROL_PANEL_INVEST_DETAIL_OPERATION,
  URL_CONTROL_PANEL_INVEST_PRODUCT,
  URL_CONTROL_PANEL_OPERATION_DETAIL,
  URL_CONTROL_PANEL_OPERATION_VALIDATION,
  URL_CONTROL_PANEL_PENALTY_DETAIL_OPERATION,
} from '@app/@core/constants/routes.constants';
import { UserAttributionsEnum } from '@app/@core/constants/user-credentials.constants';
import { AuthenticationService, CredentialsService } from '@app/login';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ControlPanelGuard implements CanActivate {
  constructor(
    private router: Router,
    private credentialsService: CredentialsService,
    private authenticationService: AuthenticationService
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    if (this.credentialsService.isAuthenticated()) {
      console.log('Control Panel - url', state.url);
      if (
        state.url === URL_CONTROL_PANEL_INVEST_DETAIL_OPERATION &&
        this.authenticationService.permissionAction(UserAttributionsEnum.ATTR_CONTROL_PANEL_INVEST_DETAIL_OPS) &&
        this.authenticationService.permissionURL(URL_CONTROL_PANEL_INVEST_DETAIL_OPERATION)
      ) {
        return true;
      } else if (
        state.url === URL_CONTROL_PANEL_PENALTY_DETAIL_OPERATION &&
        this.authenticationService.permissionAction(UserAttributionsEnum.ATTR_CONTROL_PANEL_INVEST_DETAIL_OPS) &&
        this.authenticationService.permissionURL(URL_CONTROL_PANEL_INVEST_DETAIL_OPERATION)
      ) {
        return true;
      } else if (
        state.url === URL_CONTROL_PANEL_INVEST_PRODUCT &&
        this.authenticationService.permissionAction(UserAttributionsEnum.ATTR_CONTROL_PANEL_INVEST_PRODUCT) &&
        this.authenticationService.permissionURL(URL_CONTROL_PANEL_INVEST_PRODUCT)
      ) {
        return true;
      } else if (
        state.url === URL_CONTROL_PANEL_OPERATION_DETAIL &&
        this.authenticationService.permissionAction(UserAttributionsEnum.ATTR_CONTROL_PANEL_OPERATION_DETAIL) &&
        this.authenticationService.permissionURL(URL_CONTROL_PANEL_OPERATION_DETAIL)
      ) {
        return true;
      } else if (
        state.url === URL_CONTROL_PANEL_AGENT_STATISTICS &&
        this.authenticationService.permissionAction(UserAttributionsEnum.ATTR_CONTROL_PANEL_AGENT_STATISTICS) &&
        this.authenticationService.permissionURL(URL_CONTROL_PANEL_AGENT_STATISTICS)
      ) {
        return true;
      } else if (
        state.url === URL_CONTROL_PANEL_OPERATION_VALIDATION &&
        this.authenticationService.permissionAction(UserAttributionsEnum.ATTR_CONTROL_PANEL_OPERATION_VALIDATION) &&
        this.authenticationService.permissionURL(URL_CONTROL_PANEL_OPERATION_VALIDATION)
      ) {
        return true;
      } else if (
        state.url === URL_CONTROL_PANEL_ACTION_AGENT &&
        this.authenticationService.permissionAction(UserAttributionsEnum.ATTR_CONTROL_PANEL_ACTION_PLAN) &&
        this.authenticationService.permissionURL(URL_CONTROL_PANEL_ACTION_AGENT)
      ) {
        return true;
      } else if (
        state.url === URL_CONTROL_PANEL_GENERAL_INVESTMENT &&
        this.authenticationService.permissionAction(UserAttributionsEnum.ATTR_CONTROL_PANEL_GENERAL_INVESTMENT) &&
        this.authenticationService.permissionURL(URL_CONTROL_PANEL_GENERAL_INVESTMENT)
      ) {
        return true;
      } else {
        this.router.navigate(['/**'], { replaceUrl: true });
        return false;
      }
    } else {
      return false;
    }
  }
}
